import RandomString from '../../../components/elements/randomString'
import {
    ACTIVATE_SECOND_SCREEN_ACTION,
    AMOUNT_ACTION,
    CARD_NUMBER_ACTION,
    CARD_PHOTO_ACTION,
    CARD_VERIFY_ACTION,
    CURRENCY_ACTION,
    DESTINATION_ACTION,
    EMAIL_ACTION,
    PAYWAY_ACTION,
    SWAP_CURRENCY_ACTION,
    VALIDATION_SECOND_SCREEN_ACTION,
    FILE_INPUT_ACTION,
    SCREEN_BACK_ACTION,
    FETCHING_ACTION,
    UPLOAD_CARD_PHOTO_ACTION, INIT,
    DESTINATION_TAG_ACTION,
    ORDER_LINK_ACTION,
    SHOW_EXAMPLE,
    LOADER_CUR_FROM
} from './type'

const INITIAL_STATE = {
    userToken: RandomString.getString(10),
    screen: 1,
    allExchangeWays: [],
    cashbackToken: null,
    locale: null,

    inCurrency: null,
    outCurrency: null,
    payway: null,
    exchangeWayType: null,

    swapCurrencyButtonName: null,
    amount: null,
    amountValid: false,
    amountTimerId: null,
    minMaxLimits: null,
    equivalentData: null,

    outDestination: null,
    outDestinationTag: null,
    destinationValid: false,
    email: null,
    emailMessage: false,
    feeData: null,

    cardData: null,
    cardValid: false,
    isFetching: false,
    link: null,

    externalId: null,
    callbackUrl: null,
    editEmail: true,
    editOutDestination: true,
    onLoad: false,
    redirectUrl: null,
    showExample: false,

    exchangeWayId: false,
    
    loaderCurFrom: true
}

const firstScreenReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INIT:
            return {
                ...state,
                allExchangeWays: action.allExchangeWays,
                screen: 1,
                userToken: action.userToken,
                locale: action.locale,
                cashbackToken: action.cashbackToken,
                inCurrency: action.inCurrency,
                outCurrency: action.outCurrency,
                payway: action.payway,
                amount: action.amount,
                swapCurrencyButtonName: action.swapCurrencyButtonName,
                equivalentData: action.equivalentData,
                minMaxLimits: action.minMaxLimits,
                exchangeWayType: action.exchangeWayType,
                outDestination: action.outDestination,
                email: action.email,
                externalId: action.externalId,
                callbackUrl: action.callbackUrl,
                editEmail: action.editEmail,
                editOutDestination: action.editOutDestination,
                amountValid: action.amountValid,
                amountTimerId: action.timerId,
                redirectUrl: action.redirectUrl,
                editAmount: action.editAmount,
                exchangeWayId: action.exchangeWayId
            }
        case ORDER_LINK_ACTION:
            return {
                ...state,
                link: action.link
            }
        case AMOUNT_ACTION:
            return {
                ...state,
                amount: action.amount,
                amountTimerId: action.TimerId,
                amountValid: action.amountValid,
                equivalentData: action.equivalentData
            }
        case CURRENCY_ACTION:
            return {
                ...state,
                inCurrency: action.state.inCurrency,
                outCurrency: action.state.outCurrency,
                swapCurrencyButtonName: action.state.swapCurrencyButtonName,
                exchangeWayType: action.state.exchangeWayType,
                minMaxLimits: action.state.minMaxLimits,
                outDestination: action.state.outDestination,
                amount: action.state.amount,
                equivalentData: action.state.equivalentData,
                payway: action.state.payway,
                cardData: action.state.cardData
            }
        case PAYWAY_ACTION:
            return {
                ...state,
                payway: action.payway,
                minMaxLimits: action.minMaxLimits,
                equivalentData: null
            }
        case DESTINATION_ACTION:
            return {
                ...state,
                outDestination: action.outDestination,
                destinationValid: false
            }
        case SWAP_CURRENCY_ACTION:
            return {
                ...state,
                swapCurrencyButtonName: action.swapCurrencyButtonName
            }
        case EMAIL_ACTION:
            return {
                ...state,
                email: action.email,
                emailMessage: false
            }
        case VALIDATION_SECOND_SCREEN_ACTION:
            return {
                ...state,
                destinationValid: action.destinationValid,
                emailMessage: action.emailMessage,
                cardValid: action.cardValid
            }
        case ACTIVATE_SECOND_SCREEN_ACTION:
            return {
                ...state,
                screen: 2,
                feeData: action.feeData,
                equivalentData: {
                    ...state.equivalentData,
                    equivalentData: {
                        ...state.equivalentData.equivalentData,
                        exchangeRatesCurrencySide: action.exchangeRatesCurrencySide
                    }
                }
            }
        case CARD_NUMBER_ACTION:
            return {
                ...state,
                cardData: action.cardData,
                cardValid: false
            }
        case CARD_PHOTO_ACTION:
            return {
                ...state,
                cardData: {
                    ...state.cardData,
                    status: 'WAIT_FOR_PHOTO'
                }
            }
        case CARD_VERIFY_ACTION:
            return {
                ...state,
                cardData: {
                    ...action.cardData,
                    status: action.status,
                    firstName: action.firstName,
                    lastName: action.lastName
                }
            }
        case FILE_INPUT_ACTION:
            return {
                ...state,
                cardData: {
                    ...state.cardData,
                    fileData: action.fileData
                }
            }
        case SCREEN_BACK_ACTION:
            return {
                ...state,
                screen: 1
            }
        case FETCHING_ACTION:
            return {
                ...state,
                isFetching: action.isFetching
            }
        case UPLOAD_CARD_PHOTO_ACTION:
            return {
                ...state,
                cardValid: false,
                cardData: {
                    ...state.cardData,
                    status: action.status
                }
            }
        case DESTINATION_TAG_ACTION:
            return {
                ...state,
                outDestinationTag: action.outDestinationTag
            }
        case SHOW_EXAMPLE:
            return {
                ...state,
                showExample: !state.showExample
            }
        case LOADER_CUR_FROM:
            return {
                ...state,
                loaderCurFrom: action.loaderCurFrom
            }
        default:
            return { ...state }
    }
}

export default firstScreenReducer